<template>
  <a-modal :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'entryName', validatorRules.entryName]"
            @click="handleUserInputClick" placeholder="请输入项目名称"></a-input>
        </a-form-item>

        <a-form-item label="模块名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag :triggerChange="true" dictCode="administration_feedback_area"
            v-decorator="[ 'moduleName', validatorRules.moduleName]" placeholder="请选择模块名称">
          </j-dict-select-tag>
        </a-form-item>
        <a-form-item label="表名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readOnly v-decorator="[ 'fieldName', validatorRules.fieldName]" placeholder="请输入表名"></a-input>
        </a-form-item>
        <!-- <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'managerRemarks', validatorRules.managerRemarks]" placeholder="请输入备注"></a-input>
        </a-form-item> -->

      </a-form>
      <select-user-modal ref="selectUserModal" :onlySelectOne="true" @selectChoosed="selectUserOK"></select-user-modal>
    </a-spin>
  </a-modal>
</template>

<script>
  import {
    httpAction
  } from '@/api/manage'
  import pick from 'lodash.pick'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import SelectUserModal from '@/views/gisFactoryInspection/modules/SelectUserModal'

  export default {
    name: "FeedbackManagerModal",
    components: {
      JDictSelectTag,
      SelectUserModal
    },
    data() {
      return {
        form: this.$form.createForm(this),
        title: "操作",
        width: 800,
        visible: false,
        model: {},
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 5
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        confirmLoading: false,
        validatorRules: {
          entryName: {
            rules: []
          },
          moduleName: {
            rules: []
          },
          fieldName: {
            rules: []
          }

        },
        url: {
          add: "/administration.base/feedbackManager/add",
          edit: "/administration.base/feedbackManager/edit",
        }
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, ))
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据", formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, ))
      },
      selectUserOK(userObj) {
        this.form.setFieldsValue({
          'managerUserCode': userObj[0].username
        })
      },
      handleUserInputClick() {
        this.$refs.selectUserModal.add();
      }
    }
  }
</script>